import Layout from '@/layout/index.vue'
import Vue from 'vue'
import Router, { Route } from 'vue-router'
import { NavigationGuardNext, Position } from 'vue-router/types/router'
import { getToken, setToken } from '@/utils/cookies'
import { setUserInfo } from '@/utils/user'
import AES from '@/utils/aes'
import i18n from '@/lang'
Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
    keepAlive: true
  }
*/

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/data-board',
    meta: {
      title: i18n.t('Manajemen pinjaman'),
      icon: 'example'
    },
    children: [
      {
        path: 'data-board', // Data overview
        component: () => import(/* webpackChunkName: "data-board" */ '@/views/data-board/index.vue'),
        meta: {
          title: i18n.t('Ringkasan Data')
        }
      },
      {
        path: 'lend-qoala', // Subject matter insured
        component: () => import(/* webpackChunkName: "lend-qoala" */ '@/views/lend-qoala/index.vue'),
        meta: {
          title: i18n.t('Asuransi target')
        }
      },
      {
        path: 'query-bid', // Target query
        component: () => import(/* webpackChunkName: "query-bid" */ '@/views/query-bid/index.vue'),
        meta: {
          title: i18n.t('Pencairan target')
        }
      },
      {
        path: 'bid-loan', // Target purchase
        component: () => import(/* webpackChunkName: "bid-loan" */ '@/views/bid-loan/index.vue'),
        meta: {
          title: i18n.t('Pembelian Target')
        }
      },
      {
        path: 'bid-details',
        component: () => import(/* webpackChunkName: "bid-details" */ '@/views/bid-details/index.vue'),
        meta: {
          title: i18n.t('Info lengkap target'),
          hidden: true
        }
      }
    ]
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/user/Login.vue'),
    meta: {
      title: i18n.t('Login'),
      hidden: true,
      keepAlive: true
    }
  },
  {
    path: '/register',
    components: {
      default: {
        render: (h: any) => h('router-view')
      }
    },
    meta: {
      title: i18n.t('Register'),
      hidden: true
    },
    children: [
      {
        path: 'platform',
        component: () => import(/* webpackChunkName: "Register" */ '@/views/register/index.vue')
      },
      // Enterprise Register
      {
        path: 'platform-enterprise',
        component: () =>
          import(
            /* webpackChunkName: "Platform-enterprise" */ '@/views/register/enterprise/Platform.vue'
          )
      },
      {
        path: 'third-party-binding',
        component: () =>
          import(
            /* webpackChunkName: "Third-party-binding" */ '@/views/register/enterprise/ThirdPartyBinding.vue'
          )
      },
      {
        path: 'supplementary',
        component: () =>
          import(
            /* webpackChunkName: "Supplementary" */ '@/views/register/enterprise/Supplementary.vue'
          )
      },
      {
        path: 'success',
        component: () =>
          import(/* webpackChunkName: "Register-success" */ '@/views/register/enterprise/Success.vue')
      },
      // Individual Register
      {
        path: 'platform-individual',
        component: () =>
          import(
            /* webpackChunkName: "Platform-individual" */ '@/views/register/individual/Platform.vue'
          )
      },
      {
        path: 'digisign', // Registerdigisign
        component: () =>
          import(/* webpackChunkName: "Digisign" */ '@/views/register/individual/Digisign.vue')
      },
      {
        path: 'RDL', // RegisterRDL
        component: () => import(/* webpackChunkName: "RDL" */ '@/views/register/individual/RDL.vue')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]

const scrollBehavior = (to: Route, from: Route, savedPosition: void | Position) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior,
  base: process.env.BASE_URL,
  routes
})

const whiteList = [
  '/login',
  '/register/platform',
  '/register/platform-individual',
  '/register/platform-enterprise',
  '/register/third-party-binding',
  '/register/supplementary',
  '/register/success'
]

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  /*
    Cross end login
  */
  if (to.query.data) {
    const decryptedBackToOriginal: any = AES.decryptAes(to.query.data)
    const data = JSON.parse(decryptedBackToOriginal)
    setUserInfo(data)
    setUserInfo('email', to.query.email)
    setToken(data.cookieToken)
  }

  if (!getToken() && !whiteList.find(item => to.path.startsWith(item))) {
    next('/login')
  } else {
    next()
  }
})

export default router
